import React from 'react';
import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <>
      <Link to='/admin/clients'>Admin</Link>
    </>
  );
}

export default HomePage;
